// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"142df1e8","550":"a0595abe","842":"efd612bb","917":"f3952f8e"}[chunkId] + ".chunk.css";
};